import { IBusquedaPosition } from '../../../interfaces/Position/Position'
import { actionTypes, ReducerPosition } from '../types/'

/*
Copyright 2022-08-24 por miguel balloqui Ecomsur Holding S.A ©
Detalle:
*/

export const createInitialValue = {
  id: 0,
  positionCode: '',
  positionName: '',
  positionDescription: '',
  active: false
}

export const busquedaInitialState: IBusquedaPosition = {
  positionName: '',
  subzoneId: -1,
  warehouseId: -1,
  zoneId: -1,
  typepositionId: -1,
  active: -1
}

export const initialState: ReducerPosition = {
  open: false,
  idForDelete: undefined,
  openDelete: false,
  openView: false,
  openRedireccion: false,
  page: 0,
  rowsPerPage: 5,
  totalItems: 0,
  openSnackbar: false,
  messageColor: '',
  messageStatus: '',
  rows: [],
  busqueda: busquedaInitialState,
  gridStatus: 'terminado',
  gridError: '',
  filters: [],
  almacenesDDL: [],
  isLoading: false,
  editableItem: {
    id: 0,
    warehouseId: 0,
    subZone: {
      subZoneId: 0,
      subZoneName: '',
      zoneId: 0
    },
    positionName: '',
    positionCode: '',
    positionDescription: '',
    active: false,
    subZoneId: undefined,
    typePositionId: 0,
    zone: {
      zoneId: 0,
      zoneName: ''
    },
    zoneId: undefined,
    externalStorage: false,
    listSubZones: []
  },
  allSubZones: [],
  subZonesInZone: [],
  typePositionDDL: {
    items: []
  },
  zonesDDL: [],
  redirect: false,
  loaderName: false,
  posiciones: [],
  sorters: [],
  itemsQuantity: 0,
  firstEffect: true,
  openPositionMassive: false,
  editModePositionMasive: false,
  loadingExport: false
}

// Creación del reducer el cual recibira como parametro nuestro estado y nuestras acciones
export const positionReducer = (
  state: ReducerPosition,
  action: actionTypes
) => {
  switch (action.type) {
    case 'SWITCH_MODAL':
      return {
        ...state,
        open: action.payload
      }
    case 'SWITCH_MODAL_DELETE':
      return {
        ...state,
        openDelete: action.payload
      }
    case 'SWITCH_MODAL_VIEW':
      return {
        ...state,
        openView: action.payload
      }
    case 'SWITCH_MODAL_REDIRECCION':
      return {
        ...state,
        openRedireccion: action.payload
      }
    case 'CHANGE_PAGE':
      return {
        ...state,
        page: action.payload
      }

    case 'SET_ID_FOR_DELETE': {
      return {
        ...state,
        idForDelete: action.payload
      }
    }

    case 'CHANGE_PAGE_SIZE':
      return {
        ...state,
        rowsPerPage: action.payload
      }
    case 'SET_TOTAL_ITEMS':
      return {
        ...state,
        totalItems: action.payload
      }
    case 'SWITCH_EDITABLE_ITEM':
      return {
        ...state,
        editableItem: action.payload
      }
    case 'SWITCH_SNACKBAR':
      return {
        ...state,
        openSnackbar: action.payload
      }

    case 'SET_MESSAGE_COLOR':
      return {
        ...state,
        messageColor: action.payload
      }
    case 'SET_MESSAGE_STATUS':
      return {
        ...state,
        messageStatus: action.payload
      }
    case 'SET_ROWS':
      return {
        ...state,
        rows: action.payload
      }
    case 'SET_BUSQUEDA': {
      return {
        ...state,
        busqueda: action.payload
      }
    }

    case 'SET_GRID_STATUS': {
      return {
        ...state,
        gridStatus: action.payload
      }
    }
    case 'SET_GRID_ERROR': {
      return {
        ...state,
        gridError: action.payload
      }
    }
    case 'SET_FILTERS': {
      return {
        ...state,
        filters: action.payload
      }
    }
    case 'SET_ALMACENES_DDL': {
      return {
        ...state,
        almacenesDDL: action.payload
      }
    }
    case 'SET_IS_LOADING': {
      return {
        ...state,
        isLoading: action.payload
      }
    }

    case 'SET_ALL_SUBZONES': {
      return {
        ...state,
        allSubZones: action.payload
      }
    }

    case 'SET_SUBZONES_INZONE': {
      return {
        ...state,
        subZonesInZone: action.payload
      }
    }

    case 'SAVE_TYPE_POSITION_DDL': {
      return {
        ...state,
        typePositionDDL: action.payload
      }
    }

    case 'SET_ZONE_DDL': {
      return {
        ...state,
        zonesDDL: action.payload
      }
    }

    case 'SET_REDIRECT': {
      return {
        ...state,
        redirect: action.payload
      }
    }

    case 'SET_LOADER_NAME': {
      return {
        ...state,
        loaderName: action.payload
      }
    }

    case 'SET_POSICIONES': {
      return {
        ...state,
        posiciones: action.payload
      }
    }

    case 'SET_SORTERS': {
      return {
        ...state,
        sorters: action.payload
      }
    }

    case 'SET_ITEMS_QUANTITY': {
      return {
        ...state,
        itemsQuantity: action.payload
      }
    }

    case 'SET_FIRST_EFFECT': {
      return {
        ...state,
        firstEffect: action.payload
      }
    }

    case 'SWITCH_MODAL_POSITION_MASSIVE':
      return {
        ...state,
        openPositionMassive: action.payload
      }

    case 'SET_EDIT_MODE_POSITION_MASSIVE':
      return {
        ...state,
        editModePositionMasive: action.payload
      }

    case 'SET_LOADING_EXPORT':
      return {
        ...state,
        loadingExport: action.payload
      }
    default:
      return state
  }
}
